module.exports = __webpack_public_path__ + "static/logo-merce-cecb2f072594098817e284b5cbd9df80.svg";